<template>
  <div>
    <h1>Neue Liga erstellen</h1>
    <input v-model="newLeagueName" placeholder="Name der Liga" />
    <button @click="createLeague">Liga erstellen</button>

    <h2>Teams zur Liga hinzufügen</h2>
    <input v-model="newTeamName" placeholder="Team Name" />
    <button @click="addTeam">Team hinzufügen</button>

    <ul>
      <li v-for="(team, index) in teams" :key="index">{{ team }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newLeagueName: '',
      newTeamName: '',
      teams: []
    };
  },
  methods: {
    createLeague() {
      console.log('Liga erstellt:', this.newLeagueName);
    },
    addTeam() {
      if (this.newTeamName !== '') {
        this.teams.push(this.newTeamName);
        this.newTeamName = '';
      }
    }
  }
};
</script>
